import { useState } from 'react';
import { Button } from 'react-bootstrap';
import useAlert from '../../../Alerts/useAlert';
import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import ManageLabResultsDialog from '../../../Dialogs/ManageLabResultsDialog';
import { LabResult } from '../../../Types/LabResult';

interface ManageLabResultsProps {
    lotNumber: string,
    labResults: LabResult[],
    includeSampleIds: string[],
    excludeSampleIds: string[],
    getLotDetail: Function
}

function ManageLabResults({ lotNumber, labResults, includeSampleIds, excludeSampleIds, getLotDetail }: ManageLabResultsProps) {

    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();

    const [showManageLabResultsDialog, setShowManageLabResultsDialog] = useState(false);

    const handleManageLabResultsSave = (comment: string, include: string[], exclude: string[]) => {

        fetchDataAuthenticated(`/api/v1/lot/${lotNumber}/sampleOverrides`, 'PUT', JSON.stringify({ comment: comment, include: include, exclude: exclude }))
            .then(async response => {
                if (response.ok) {
                    getLotDetail();
                    setShowManageLabResultsDialog(false);
                } else {
                    throw new Error("Failed to add the comment to the lot");
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            });
    }

    return (
        <>
            <Button variant="primary" onClick={() => setShowManageLabResultsDialog(true)}>Manage Lab Results</Button>
            <ManageLabResultsDialog showDialog={showManageLabResultsDialog} closeDialog={() => setShowManageLabResultsDialog(false)} onSave={handleManageLabResultsSave} labResults={labResults} includeSampleIds={includeSampleIds} excludeSampleIds={excludeSampleIds} />
        </>
    );
}

export default ManageLabResults;